import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { mdiDownload } from '@mdi/js';
import Icon from '@mdi/react';

import Button from 'components/UIComponents/Button';
import DescriptionList, {
  Description,
} from 'components/UIComponents/DescriptionList';
import { Column, Row, Section } from 'components/UIComponents/Layout';
import Table, { TableHeader } from 'components/UIComponents/Table';
import { Heading } from 'components/UIComponents/Typography';
import { getObligationXsd } from 'store/entities/submissionDetail/thunks';

export default () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    submissionDetail: { obligation = {} },
  } = useSelector(state => state.submissionDetail);

  const {
    requiredRowDtos,
    id: obligationId,
    xsdName,
    filetype,
    columnSeparator,
    stringAttribute,
    decimalSeparator,
    status: obligationStatus,
    generateXsd,
  } = obligation;

  return (
    <Section size="medium">
      <Row>
        <Column className="scroll-x">
          <Heading
            id="obligation-detail-file-structure"
            aria-label="Obligation detail file structure"
            size={6}
          >
            {t('datagate.external.submissionDetail.subtitle.fileStructure')}
          </Heading>
          <div>
            <DescriptionList vertical>
              <Description
                id="obligation-detail-filetype"
                aria-label="Obligation detail filetype"
                highlighted
                field={t('datagate.external.submissionDetail.label.filetype')}
                value={filetype}
              />
              {['CSV', 'TXT'].includes(filetype) && (
                <>
                  <Description
                    id="obligation-detail-column-separator"
                    aria-label="Obligation detail column separator"
                    highlighted
                    field={t(
                      'datagate.external.submissionDetail.label.columnSeparator'
                    )}
                    value={columnSeparator}
                  />
                  <Description
                    id="obligation-detail-string-attribute"
                    aria-label="Obligation detail string attribute"
                    highlighted
                    field={t(
                      'datagate.external.submissionDetail.label.stringAttribute'
                    )}
                    value={stringAttribute}
                  />
                  <Description
                    id="obligation-detail-decimal-separator"
                    aria-label="Obligation detail decimal separator"
                    highlighted
                    field={t(
                      'datagate.external.submissionDetail.label.decimalSeparator'
                    )}
                    value={decimalSeparator}
                  />
                </>
              )}
              {filetype === 'XML' &&
                generateXsd &&
                obligationStatus !== 'INACTIVE' && (
                  <Button
                    color="primary"
                    outlined
                    id="obligation-detail-xsd-btn"
                    aria-label="Obligation detail xsd button"
                    onClick={() =>
                      dispatch(
                        getObligationXsd({
                          obligationId,
                          fileName: xsdName,
                        })
                      )
                    }
                  >
                    <Icon path={mdiDownload} size={0.8} />{' '}
                    {t('datagate.external.submissionDetail.button.xsd')}
                  </Button>
                )}
            </DescriptionList>
          </div>
          <Table
            striped={false}
            id="obligation-detail-file-structure-table"
            aria-label="Obligation detail file structure table"
          >
            <TableHeader
              columnData={[
                t(
                  'datagate.external.submissionDetail.table.fileStructure.column.nr'
                ),
                t(
                  'datagate.external.submissionDetail.table.fileStructure.column.name'
                ),
                t(
                  'datagate.external.submissionDetail.table.fileStructure.column.description'
                ),
                t(
                  'datagate.external.submissionDetail.table.fileStructure.column.dataType'
                ),
                t(
                  'datagate.external.submissionDetail.table.fileStructure.column.dataSubType'
                ),
                t(
                  'datagate.external.submissionDetail.table.fileStructure.column.pattern'
                ),
                t(
                  'datagate.external.submissionDetail.table.fileStructure.column.length'
                ),
                t(
                  'datagate.external.submissionDetail.table.fileStructure.column.mandatory'
                ),
              ]}
            />
            <tbody>
              {requiredRowDtos &&
                requiredRowDtos.map((row, i) => (
                  <tr key={'tree-table-' + i}>
                    <th>{row.seqNumber}</th>
                    <td>{row.name}</td>
                    <td>{row.description}</td>
                    <td>{row.dataType}</td>
                    <td>{row.dataSubType}</td>
                    <td>{row.pattern}</td>
                    <td>{row.length}</td>
                    <td>
                      {row.mandatory
                        ? t('datagate.external.global.yes')
                        : t('datagate.external.global.no')}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </Column>
      </Row>
    </Section>
  );
};
